// JavaScript Document
import debounce from 'lodash.debounce';

import jsKit from './modules/jsKit';
import ams from './modules/ams';
import {swipers} from "./modules/swipers";
import { RippleEffect } from './modules/ripple';
import navScroll from './modules/navScroll';
import { setupFilterSearch, resetFilterSearch } from './modules/filterSearch';
//import './modules/darkMode'

import 'bootstrap';
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

window._ = window._ || {};
window._.debounce = debounce;

window.textStorageXML = ams.textStorageXML;
window.money = ams.money;
window.getConfig = ams.getConfig;
window.loadPage = ams.loadPage;
window.insertHtml = (...args) => ams.insertHtml(...args);
window.getProductAjax = (...args) => ams.getProductAjax(...args);
window.czytajStan = (...args) => ams.readAvailability(...args);
window.ustawCeny = (...args) => ams.setPrices(...args);
window.changeRabat = (...args) => ams.changeRabat(...args);
window.initDynamicContent = (...args) => ams.initDynamicContent(...args);
window.initTextFilter = (...args) => ams.initTextFilter(...args);
window.focusOnModalShow = (...args) => ams.focusOnModalShow(...args);
window.initCarousel = (...args) => ams.initCarousel(...args);
window.initClickableRows = (...args) => ams.initClickableRows(...args);
window.clearInput = (...args) => ams.clearInput(...args);
window.deleteVehicle = (...args) => ams.deleteVehicle(...args);

import Cookies from 'js-cookie';
import {addBackToTop} from 'vanilla-back-to-top';

const amsEvents = [
    ['jsUserLogin', (e) => ams.userLogin(e)],
    ['jsUserLogout', (e) => ams.userLogout(e)],

    ['jsShowSearchResult', debounce((e) => ams.showSearchResult(e), 1000), 'input'],
    ['jsFilterResult', (e) => ams.filterResult(e), 'change'],
    ['jsSubmitSearchForm', (e) => ams.submitSearchForm(e)],

    ['jsMarkiScopeSwitch', (e) => ams.markiScopeSwitch(e), 'change'],
    ['jsInitMarkiSelect', () => ams.initMarkiChoices(), 'DOMContentLoaded'],
    ['jsOpenMarkiModal', (e) => ams.openMarkiModal(e)],
    ['jsOpenCarSearchModal', (e) => ams.openCarSearchModal(e)],
    ['jsCategoryModalData', (e) => ams.categoryModalData(e)],
    ['jsSendQuestion', (e) => ams.sendQuestion(e)],

    ['jsChangeRabat', (e) => ams.changeRabat(e)],
    ['jsClearInput', (e) => ams.clearInput(e.delegateTarget.dataset.jsClearInput)],

    ['jsSendOrder', (e) => ams.sendOrder(e), 'change'],
    ['jsPayWithPayU', (e) => ams.payWithPayU(e)],
    ['jsToggleOrderDetails', (e) => ams.toggleOrderDetails(e)],

    ['jsDeleteItem', (e) => ams.deleteItem(e)],
    ['jsSendItem', (e) => ams.sendItem(e)],
    ['jsSendItemChange', (e) => ams.sendItem(e), 'change'],

    ['jsSaveVehicle', (e) => ams.saveVehicle(e)],
    ['jsShowVehicleHistory', (e) => ams.showVehicleHistory(e)],
    ['jsDeleteVehicleHistory', (e) => ams.deleteVehicleHistory(e)],

    ['jsPinAdd', (e) => ams.pinAdd(e)],
    ['jsRemovePin', (e) => ams.removePin(e)],
    ['jsDataNext', (e) => ams.dataNext(e)],
    ['jsToggleProducts', (e) => ams.toggleProducts(e)],
    ['jsProductFilter', (e) => ams.productFilter(e), 'change'],
    ['jsCheckLocFilters', () => ams.checkLocFilters(), 'DOMContentLoaded'],
    ['jsLocFilter', (e) => ams.locFilter(e), 'change'],
    ['jsAmountFilter', (e) => ams.amountFilter(e), 'change'],
    ['jsProductToggle', (e) => ams.productToggle(e), 'change'],
    ['jsSortProducts', (e) => ams.sortProducts(e)],
    ['jsChangeLayout', (e) => ams.changeLayout(e), 'change'],
    ['jsToggleSideMenu', (e) => ams.toggleSideMenu(e)],

    ['jsFilterSearch', (e) => setupFilterSearch(e), 'input'],
    ['jsFilterReset', (e) => resetFilterSearch(e), 'click'],

    ['jsModalData', (e) => jsKit.modalData(e)],
    ['jsContainerData', (e) => jsKit.containerData(e)],
    ['jsGetDataForm', (e) => jsKit.getDataForm(e)],
    ['jsModalCookies', (e) => jsKit.modalCookies(e)],
    ['jsHistoryBack', (e) => jsKit.historyBack(e)],

    ['jsLoadCollapse', (e) => ams.loadCollapse(e)],
    ['jsListFilter', debounce((e) => ams.listFilter(e), 300), 'input'],
    ['jsLoadList', debounce((e) => ams.loadList(e), 300), 'input'],
    ['jsDeleteVehicle', (e) => ams.deleteVehicle(e.delegateTarget.dataset.jsDeleteVehicle)],
    ['jsClearCatalogPar', (e) => ams.clearCatalogParams(e)],
    ['jsClearCatalogParInput', (e) => ams.clearCatalogParamInput(e)],
    ['jsImportStorage', (e) => ams.importStorageXml(e)],
    ['jsSaveValuation', (e) => ams.saveValuation(e)],
];

const registerAmsEvents = () => {
    amsEvents.forEach(([dataItem, handler, eventName]) => {
        jsKit.attachEventByDataSet(dataItem, handler, eventName);
    });
};

document.addEventListener('DOMContentLoaded', function(){
    ams.insertHtml();
    ams.initDynamicContent(document);

    swipers.mainSwiperInit();
    swipers.swiperProductCardInit();
    //ams.imageZoomInit(); // brakuje dużych zdjęć

    // init maintenance modal
    // jsKit.showModal('#maintenance-modal');


    // init tooltip
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    jsKit.initTooltip(tooltipTriggerList);

    if (document.querySelectorAll('.nav-scroll')) {
        navScroll(document.querySelectorAll('.nav-scroll'));
    }

    ams.basketCount();
    ams.pinCount();
    ams.hasCarIdHistory();
    ams.setPrices();
    ams.getProductAjax();
    ams.calculateAvailabilityDeferred();

    let layout = ams.getLocal("ly", 0);
    if (!layout) {
        layout = 'grid';
    }
    ams.setLayout(layout);

    addBackToTop({
        diameter: 56,
        backgroundColor: '#FFFFFF',
        textColor: '#F28300',
        innerHTML: ''
    });

    if(!Cookies.get('_cookieSettingsRequired')) {
        jsKit.modalCookies({target: {dataset: {jsModalCookies: "make.asp?i=c"}}} );
    }

    registerAmsEvents();

}, false);
